"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

// Todo: What is this component? What uses it? Classes are misleading w/ colors
// and color props dont exist
var styles = function styles(theme) {
  return {
    body: {
      backgroundColor: theme.palette.secondaryInfo.background,
      border: theme.palette.secondaryInfo.border,
      color: theme.palette.secondaryInfo.color,
      borderRadius: 4,
      padding: 12,
      marginTop: 8
    },
    warning: {
      backgroundColor: theme.palette.info.background,
      border: theme.palette.info.border,
      color: theme.palette.info.color,
      borderRadius: 4,
      padding: 12,
      marginTop: 8
    },
    stop: {
      backgroundColor: theme.palette.warning.background,
      border: theme.palette.warning.border,
      color: theme.palette.warning.color,
      borderRadius: 4,
      padding: 12,
      marginTop: 8
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var BackgroundContainer = function BackgroundContainer(_ref) {
  var children = _ref.children,
      backgroundColor = _ref.backgroundColor;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes[backgroundColor]
  }, children);
};

BackgroundContainer.propTypes = {
  backgroundColor: _propTypes["default"].oneOf(['body', 'warning', 'stop']).isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = BackgroundContainer;
exports["default"] = _default;